module.exports = __webpack_public_path__ + "static/media/emma-watson-icon.cee8c31a.jpg";